import * as types from "../../actionTypes/Dashboard/eurailPassActionTypes";

const initial = {
  EurailPassCountries: {},
  EurailPassSearch: {},
  GetEurailPassList: {},
  EurailPassPreBookDetails: {},
  EurailPassCheckoutDetails: {},
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EurailPassReducer = (state = initial, action: any) => {
  switch (action.type) {
    // ------------------> EURAIL_PASS_COUNTRIES start
    case types.EURAIL_PASS_COUNTRIES.FULLFILLED:
      return { ...state, EurailPassCountries: action.payload };
    case types.EURAIL_PASS_COUNTRIES.REJECTED:
      return { ...state, EurailPassCountries: {} };
    // ------------------> EURAIL_PASS_COUNTRIES end

    // ------------------> EURAIL_PASS_SEARCH start
    case types.EURAIL_PASS_SEARCH.FULLFILLED:
      return { ...state, EurailPassSearch: action.payload };
    case types.EURAIL_PASS_SEARCH.REJECTED:
      return { ...state, EurailPassSearch: {} };
    // ------------------> EURAIL_PASS_SEARCH end

    // ------------------> GET_EURAIL_PASS_LIST start
    case types.GET_EURAIL_PASS_LIST.FULLFILLED:
      return { ...state, GetEurailPassList: action.payload };
    case types.GET_EURAIL_PASS_LIST.REJECTED:
      return { ...state, GetEurailPassList: {} };
    // ------------------> GET_EURAIL_PASS_LIST end

    // ------------------> EURAIL_PASS_PRE_BOOK start
    case types.EURAIL_PASS_PRE_BOOK.FULLFILLED:
      return { ...state, EurailPassPreBookDetails: action.payload };
    case types.EURAIL_PASS_PRE_BOOK.REJECTED:
      return { ...state, EurailPassPreBookDetails: {} };
    // ------------------> EURAIL_PASS_PRE_BOOK end

    // ------------------> EURAIL_PASS_CHECKOUT start
    case types.EURAIL_PASS_CHECKOUT.FULLFILLED:
      return { ...state, EurailPassCheckoutDetails: action.payload };
    case types.EURAIL_PASS_CHECKOUT.REJECTED:
      return { ...state, EurailPassCheckoutDetails: {} };
    // ------------------> EURAIL_PASS_CHECKOUT end
    case "clear_EurailPassList": {
      return { ...state, GetEurailPassList: {} };
    }
    default:
      return state;
  }
};

export default EurailPassReducer;
